/**
 * Google Maps の円形マーカー（Leafletの CircleMarker 相当）
 *
 * google.maps.Circle は半径がメートル単位でズームに追従して大きさが変わるため、
 * ピクセル固定サイズを維持できる AdvancedMarker + CSS の丸で実装する。
 */

import { AdvancedMarker } from '@vis.gl/react-google-maps'
import type { Ref } from 'react'

import { hexToRgba } from './google-maps-config'

/** マーカー中心を座標に合わせる（anchorLeft/anchorTop はコンテンツをずらす量なので負値） */
const ANCHOR_CENTER = '-50%'

type GoogleCircleMarkerProps = {
  position: google.maps.LatLngLiteral
  /** 半径（ピクセル） */
  radius: number
  /** 枠線の色（16進） */
  color: string
  /** 塗りの色（16進） */
  fillColor: string
  fillOpacity?: number
  /** 枠線の太さ（ピクセル） */
  weight?: number
  zIndex?: number
  onClick?: () => void
  /** 生成された AdvancedMarkerElement を受け取る ref（クラスタラー登録用） */
  markerRef?: Ref<google.maps.marker.AdvancedMarkerElement>
}

export function GoogleCircleMarker({
  position,
  radius,
  color,
  fillColor,
  fillOpacity = 1,
  weight = 2,
  zIndex,
  onClick,
  markerRef,
}: GoogleCircleMarkerProps) {
  const size = radius * 2

  return (
    <AdvancedMarker
      ref={markerRef}
      position={position}
      anchorLeft={ANCHOR_CENTER}
      anchorTop={ANCHOR_CENTER}
      zIndex={zIndex}
      onClick={onClick}
    >
      <div
        className="box-content cursor-pointer rounded-full"
        style={{
          width: size,
          height: size,
          backgroundColor: hexToRgba(fillColor, fillOpacity),
          border: `${weight}px solid ${color}`,
        }}
      />
    </AdvancedMarker>
  )
}
